import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import List from "../../List/List"

class AutoPriceRulePresenterRates extends React.Component {

  constructor(props) {
    super(props)
    this.renderAutoPriceRuleRate = this.renderAutoPriceRuleRate.bind(this)
  }

  render() {
    var self = this;
    var tabClasses = clsx({
      'active': this.props.activeTab == 'rates',
      'tab-pane': true
    })
    var header = I18n.t('code') + ': ' + I18n.t('name')

    return (
      <div className={tabClasses}>
        {this.props.rates && this.props.rates.length
          ? <List
            header_primary={header}
            header_secondary='billing_policy'
            items={this.props.rates}
            display_column_primary="code name"
            show_disabled_rate={true}
            custom_display_column_secondary="billing_policy_name" />
          : <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
        }
      </div>
    )
  }

  renderAutoPriceRuleRate(rate_id) {
    var full_rate = this.props.all_rates.filter(rate => rate.id === rate_id)[0]
		return <li key={full_rate.id}>{full_rate.code}</li>
  }

}

export default AutoPriceRulePresenterRates